import { Paper, Typography, useTheme } from '@mui/material';
import { FC, useEffect, useMemo } from 'react';
import { GoPlus } from "react-icons/go";
import { useNavigate } from 'react-router-dom';
import { ConfirmDialog } from '../../../Components/Dialog/variants/dialog-confirmation/dialog-confirmation.component';
import { ActionButtons } from '../../../Components/Form/ActionButtons/action-buttons.component';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { Placeholder } from '../../../Components/Placeholder/placeholder.component';
import { Table } from '../../../Components/Table/table.component';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';


import { useListOrdersReplacement } from './replacement-order-list.hook';
import { DestroyArtsUseCase } from '../../../Usecase/Arts/destroy-arts-usecase';
import { ListArtsUseCase } from '../../../Usecase/Arts/list-arts-usecase';
import { ListOrdersReplacementUseCase } from '../../../Usecase/OrdersReplacement/list-orders-replacement-usecase';
import { Loader } from '../../../Components/Loader';
import { DestroyOrdersReplacementUseCase } from '../../../Usecase/OrdersReplacement/destroy-orders-replacement-usecase';
import { Can } from '../../../Components/Can';
import { LinkClipBoard } from '../../../Components/LinkClipBoard/link-clip-board.component';
import { Flex } from '../../../Components/Flex/flex.component';

interface IOrdersReplacementList {
  
 
  listOrdersReplacementUseCase: ListOrdersReplacementUseCase
  destroyOrdersReplacementUseCase: DestroyOrdersReplacementUseCase
}
const OrdersReplacementList : FC<IOrdersReplacementList> = ({  listOrdersReplacementUseCase, destroyOrdersReplacementUseCase }) => {
    const theme = useTheme()
    const navigate = useNavigate()

    const { list, setOrderToDestroy, orderToDestroy, handleDestroyOrderReplacement,totalRegisters, listOrdersReplacement, loading, currentFilters, setCurrentFilters } = useListOrdersReplacement({
   
 
      listOrdersReplacementUseCase,
      destroyOrdersReplacementUseCase
      
    })

    useEffect(() => {
      listOrdersReplacement({ page: 1})
    }, [])


    const columns = useMemo(() => {
        const createColumns: any[] = [
          {
            field: 'id',
            headerName: 'Identificador Interno',
            flex: 1,
            renderCell: (params: any) => <Flex height='100%' alignItems='center'><LinkClipBoard link={params.row.id} title='Copiar Link' /><Typography>{params.row.id}</Typography></Flex>
          },
          {
            field: 'identifier',
            headerName: 'Identificador Hub',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params: any) => <Flex height='100%' alignItems='center' justifyContent='center'><Typography>{params.row.identifier}</Typography></Flex>
          },
          {
            field: 'brand',
            headerName: 'Marca',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params: any) => params.row.brand || 'Marca não informada'
          },
          {
            field: 'createdAt',
            headerName: 'Data de criação',
            headerAlign: "center",
            align: "center",
            flex: 1,
            renderCell: (params: any) => params.row.createdAt || 'Data não informada'
          },
          {
            field: 'dua',
            headerName: 'Data de Entrega',
            headerAlign: "center",
            align: "center",
            flex: 1,
            renderCell: (params: any) => params.row.dueDate || 'Data não informada'
          },
          {
            field: 'store',
            headerName: 'Loja',
            flex: 1,
            headerAlign: "center",
            align: "center",
            
          },
          {
            field: "actions",
            headerName: "Ações",
            headerAlign: "center",
            align: "center",
            width: 100,
            renderCell: (params: any) => <ActionButtons params={params} setItemToDestroy={setOrderToDestroy} editLink={`/orders-replacement-form/${params.row.id}`} />
          }
        ];
      
        return createColumns;
      }, []);
   

    return (
      <Can permissions={['menu:replacementOrders:manage']}>
        <BaseScreen>
        {loading && <Loader />}
        <ConfirmDialog title='Remover Pedido' onCancel={() => setOrderToDestroy('')} description='Você tem certeza?' open={!!orderToDestroy} onConfirm={handleDestroyOrderReplacement}  /> 
            <Paper >
                <BaseContentPage 
                    title='Pedidos de Reposição'
                    breadcrumb={[{ title: 'Pedidos de Reposição', link: "/orders-replacement-list"}, { title: 'Listagem'}]}
                    search
                    searchFunction={(data) => listOrdersReplacement({ ...currentFilters, searchBy: data.searchBy, page: data.page })}
                    Action={() => <Button LeftIcon={() => <GoPlus size={18} />} sx={{ width: '130px'}} boxLeftSx={{ gap: '10px', marginLeft: '5px'}} textSx={{ textTransform: 'Capitalize', fontWeight: 500}} onClick={() => navigate('/orders-replacement-form')}>Adicionar</Button>}
                >
                  {!!list?.length ? <Table data={list} totalCount={totalRegisters} columns={columns} onPageChange={listOrdersReplacement} /> : <Placeholder description='Nenhum dado encontrado.' />}
                </BaseContentPage>
              
            </Paper>
                
        </BaseScreen>
        </Can>
    )
}

export { OrdersReplacementList };
